var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTradeIn = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#4A4A4A",
  d: "M16.764 21.5 24 15.371l-7.236-6.129v2.452h-3.98v-1.595H3.88v1.595a7.006 7.006 0 0 0 6.955 7.006l5.93.042z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#trade-in_svg__a)",
  d: "m.251 8.629 3.958 2.896L7.672 13.9v-2.206h9.093v-2.45l3.978 3.368.048.001a7.355 7.355 0 0 0-7.354-7.355H7.72V2.5z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "trade-in_svg__a",
  x1: 20.702,
  x2: 5.685,
  y1: 4.4,
  y2: 13.482,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F4F8FC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#568DFE"
})))));
export default SvgTradeIn;